export const SHOW_LOADER = "APP/SHOW_LOADER";
export const HIDE_LOADER = "APP/HIDE_LOADER";
export const SHOW_APP_LOADER = "APP/SHOW_APP_LOADER";
export const HIDE_APP_LOADER = "APP/HIDE_APP_LOADER";